const SEAL_IMAGE =
  'https://cdn.shopify.com/s/files/1/0622/1937/files/PRODUCT_PAGE_-_FACTORY_PICTURE_MADE_IN_USA_1.png?v=1781816441';

const SEAL_RATIO = 1946 / 1093;
const SEAL_RATIO_PERCENT = (1 / SEAL_RATIO * 100).toFixed(6) + '%'; // ~56.1714%

function addMadeInUSAMedia() {
  const galleryWrapper = document.querySelector(
    '.swiper-wrapper.slider--product'
  );

  const thumbWrapper = document.querySelector(
    '.grid__item.product__media-wrapper .gallery__thumbnails .swiper-wrapper'
  );

  if (!galleryWrapper || !thumbWrapper) return;

  if (
    galleryWrapper.querySelector('.usa-seal-slide') ||
    thumbWrapper.querySelector('.usa-seal-thumbnail')
  ) {
    return;
  }

  const customMediaId = 'usa-seal';

  /* =====================================
     CLONE GALLERY SLIDE
  ===================================== */

  const lastGallerySlide = galleryWrapper.querySelector(
    '.swiper-slide.slide--product:last-child'
  );

  if (!lastGallerySlide) return;

  const gallerySlide = lastGallerySlide.cloneNode(true);

  gallerySlide.classList.add('usa-seal-slide');
  gallerySlide.id = 'custom-usa-seal';
  gallerySlide.setAttribute('data-media-id', customMediaId);
  gallerySlide.setAttribute('data-alt-text', '');
  gallerySlide.setAttribute(
    'data-swiper-slide-index',
    parseInt(lastGallerySlide.getAttribute('data-swiper-slide-index')) + 1
  );

  const emptyDivZoomIn = gallerySlide.querySelector(
    '.product-media-container > div:not([class])'
  );
  if (emptyDivZoomIn) emptyDivZoomIn.style.display = 'none';

  const galleryContainer = gallerySlide.querySelector('.product-media-container');

  if (galleryContainer) {
    galleryContainer.setAttribute('data-media-id', customMediaId);

    galleryContainer.style.setProperty('--ratio', SEAL_RATIO);
    galleryContainer.style.setProperty('--preview-ratio', SEAL_RATIO);
    galleryContainer.style.setProperty('--aspect-ratio', SEAL_RATIO);
    galleryContainer.style.setProperty('--ratio-percent', SEAL_RATIO_PERCENT);
    galleryContainer.style.border = 'none';

    galleryContainer.style.cursor = 'initial';

    const modalOpener = galleryContainer.querySelector('.product__modal-opener');
    if (modalOpener) {
      modalOpener.style.padding = '0px';

      const media = modalOpener.querySelector('.product__media');
      if (media) {
        media.style.minHeight = '';
        media.style.paddingTop = '100%';
        media.style.background = '#fcfbf7';
      }
    }
  }

  const galleryImg = gallerySlide.querySelector('img');

  if (galleryImg) {
    galleryImg.src = SEAL_IMAGE;
    galleryImg.srcset = '';
    galleryImg.alt = 'Made in USA Seal';
    galleryImg.style.objectFit = 'contain';
    galleryImg.style.objectPosition = 'center center';
  }

  galleryWrapper.appendChild(gallerySlide);

  /* =====================================
     CLONE THUMBNAIL
  ===================================== */

  const lastThumb = thumbWrapper.querySelector(
    '.swiper-slide.thumb-slide--product:last-child'
  );

  if (!lastThumb) return;

  const thumbSlide = lastThumb.cloneNode(true);

  thumbSlide.classList.add('usa-seal-thumbnail');
  thumbSlide.id = 'Slide-Thumbnails-template--22535541948505__main-usa-seal';
  thumbSlide.setAttribute('data-media-id', customMediaId);
  thumbSlide.setAttribute('data-target', 'custom-usa-seal');
  thumbSlide.setAttribute(
    'data-media-position',
    galleryWrapper.querySelectorAll('.swiper-slide.slide--product').length
  );

  thumbSlide.classList.remove('swiper-slide-thumb-active', 'swiper-slide-active');

  const thumbImg = thumbSlide.querySelector('img');

  if (thumbImg) {
    thumbImg.src = SEAL_IMAGE;
    thumbImg.srcset = '';
    thumbImg.alt = 'Made in USA Seal';
  }

  const thumbButton = thumbSlide.querySelector('button');

  if (thumbButton) {
    thumbButton.removeAttribute('aria-current');
    thumbButton.setAttribute(
      'aria-label',
      'Load image in gallery view of Made in USA Seal'
    );
  }

  thumbWrapper.appendChild(thumbSlide);

  /* =====================================
     UPDATE SWIPERS
  ===================================== */

  const gallerySwiper =
    galleryWrapper.closest('.swiper')?.swiper ||
    galleryWrapper.parentElement?.swiper;

  const thumbSwiper =
    thumbWrapper.closest('.swiper')?.swiper ||
    thumbWrapper.parentElement?.swiper;

  if (gallerySwiper) {
    gallerySwiper.update();
    gallerySwiper.updateSlides();
    gallerySwiper.updateProgress();
  }

  if (thumbSwiper) {
    thumbSwiper.update();
    thumbSwiper.updateSlides();
    thumbSwiper.updateProgress();
  }

  /* =====================================
     THUMB CLICK
  ===================================== */

  thumbButton?.addEventListener('click', () => {
    const targetIndex =
      galleryWrapper.querySelectorAll('.swiper-slide.slide--product').length - 1;

    if (gallerySwiper) {
      gallerySwiper.slideTo(targetIndex);
    }

    thumbWrapper.querySelectorAll('.thumb-slide--product').forEach((el) => {
      el.classList.remove('swiper-slide-thumb-active');
    });

    thumbWrapper.querySelectorAll('button').forEach((btn) => {
      btn.removeAttribute('aria-current');
    });

    thumbSlide.classList.add('swiper-slide-thumb-active');
    thumbButton.setAttribute('aria-current', 'true');
  });

  /* =====================================
     KEEP ACTIVE THUMB IN SYNC
  ===================================== */

  if (gallerySwiper) {
    gallerySwiper.on('slideChange', () => {
      const activeIndex = gallerySwiper.activeIndex;

      thumbWrapper.querySelectorAll('.thumb-slide--product').forEach((el) => {
        el.classList.remove('swiper-slide-thumb-active');
      });

      thumbWrapper.querySelectorAll('button').forEach((btn) => {
        btn.removeAttribute('aria-current');
      });

      const activeThumb =
        thumbWrapper.querySelectorAll('.thumb-slide--product')[activeIndex];

      if (activeThumb) {
        activeThumb.classList.add('swiper-slide-thumb-active');
        const btn = activeThumb.querySelector('button');
        if (btn) btn.setAttribute('aria-current', 'true');
      }
    });
  }

}

/* =====================================
   INIT
===================================== */

document.addEventListener('DOMContentLoaded', () => {
  addMadeInUSAMedia();

  const observer = new MutationObserver(() => {
    addMadeInUSAMedia();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});